/**
 * Application-wide settings and constants
 */

export const appSettings = {
  /**
   * OiSTER Bonus commission percentage that is added on top of customer cashback
   * Total commission = customerCashbackPercent + OISTER_COMMISSION_PERCENT
   */
  OISTER_COMMISSION_PERCENT: 1,

  /**
   * Default customer cashback percentage for new promotions
   */
  DEFAULT_CUSTOMER_CASHBACK_PERCENT: 5,

  /**
   * Billwerk customer URL base - append customer handle to get full URL
   */
  BILLWERK_CUSTOMER_BASE_URL: "https://app.frisbii.com/#/rp/customers/customers/customer",
};
